'use client'
import signOut from '@/firebase/auth/signOut'

import firebaseApp from '@/firebase/config'
import { removeStored } from '@/utils/removeStored'
import { anonymize } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { selectedMutations } from '@mercadoni/sinister/dist/cjs/shared/services'
import { getAuth } from 'firebase/auth'
import uuid from './../../../utils/uuid'
interface HandleLogoutProps {
  nofirebaseLogout?: boolean
}
const handleLogout = async ({
  nofirebaseLogout = false,
}: HandleLogoutProps = {}) => {
  const auth = getAuth(firebaseApp({}))

  anonymize(uuid())
  // TODO: logout message
  removeStored([
    'instructions',
    'lastSuggestionTime',
    'selectedOpsModel',
    'selectedAddress',
    'selectedStore',
    'storeReference',
    'selectedStoreId',
    'storeFilter',
    'token',
    'configs',
    'guestAddress',
    'customer',
    'noFed',
    'cartId',
    'storeId',
  ])
  await selectedMutations.logOut()
  if (nofirebaseLogout) {
    return
  }
  const { result } = await signOut(auth)
  if (result) {
    return '/'
  }
}

export default handleLogout
